<!-- Desktop Mode - Popover -->
<div *ngIf="!isMobileMode()" class="search-container" (click)="toggleSearch($event)">
  <button 
    #searchButton
    type="button" 
    class="search-icon-btn"
    pButton 
    pRipple>
    <fa-icon [icon]="icons.solid.faMagnifyingGlass" class="search-icon"></fa-icon>
  </button>


  <p-popover #searchPopover (onHide)="onSearchPopoverHide()" (onShow)="onSearchPopoverShow()" [styleClass]="searchResults().length > 0 ? ('centered-search-popover has-results search-popover-above-backdrop' + (!useTableScrolling() ? ' few-results-popover' : '')) : 'centered-search-popover search-popover-above-backdrop'" appendTo="body" [dismissable]="false">
    <div class="search-popover-content" (click)="$event.stopPropagation()">
      <div class="search-input-container">
        <input 
          #searchInput
          type="text"
          placeholder="Search..." 
          class="search-input"
          [(ngModel)]="searchValue"
          (input)="onInputChange($event)"
          (keyup.enter)="onEnterKeyPress()">
        <button 
          *ngIf="searchValue && searchValue.length > 0"
          type="button" 
          class="clear-button"
          (mousedown)="clearSearch(); $event.stopPropagation()"
          pTooltip="Clear search"
          tooltipPosition="bottom">
          <fa-icon [icon]="icons.solid.faXmark"></fa-icon>
        </button>
        <button 
          type="button" 
          class="search-button"
          (mousedown)="onSearchButtonClick(); $event.stopPropagation()">
          <fa-icon [icon]="icons.solid.faMagnifyingGlass"></fa-icon>
        </button>
      </div>
      
      <!-- Loading Spinner -->
      <div *ngIf="isLoading()" class="search-loading">
        <p-progressSpinner [style]="{'width': '20px', 'height': '20px'}" strokeWidth="3"></p-progressSpinner>
        <span class="ml-2">Searching...</span>
      </div>
      
      <!-- Search Error -->
      <div *ngIf="searchError()" class="search-error">
        <i class="pi pi-exclamation-triangle"></i>
        <span class="ml-2">{{ searchError() }}</span>
      </div>
      

      <!-- Search Results Table -->
      <div *ngIf="searchResults().length > 0 && !isLoading()" class="search-results" [class.few-results]="!useTableScrolling()" (click)="$event.stopPropagation()">
        <p-table 
          #searchResultsTable
          [value]="searchResults()" 
          [scrollable]="useVirtualScrolling() || useTableScrolling()"
          [scrollHeight]="useVirtualScrolling() ? 'calc(100dvh - 300px)' : (useTableScrolling() ? 'calc(100dvh - 300px)' : 'auto')"
          [stripedRows]="true"
          [sortMode]="'multiple'"
          sortField="groupId"
          [sortOrder]="1"
          [globalFilterFields]="['type', 'groupId', 'nsNum', 'name', 'company', 'phone1', 'phone2', 'email']"
          [virtualScroll]="useVirtualScrolling()"
          [virtualScrollItemSize]="46"
          [paginator]="false"
          [totalRecords]="totalResultCount()"
          styleClass="p-datatable-sm"
          (click)="$event.stopPropagation()">
          
          <ng-template pTemplate="caption">
            <div class="flex justify-between items-center" (click)="$event.stopPropagation()">
              <div class="flex items-center gap-3">
                <div class="flex gap-1">
                  <app-icon-button [icon]="icons.ppmSolid.csv" [text]="false" (onClick)="exportCSV()"
                      pTooltip="CSV" tooltipPosition="bottom"></app-icon-button>
                </div>
                <div class="text-sm text-gray-600">
                  {{ totalResultCount() }} results
                </div>
              </div>
              <div class="flex items-center gap-2">
                <app-icon-button [icon]="icons.ppmSolid.clearFilter" (onClick)="clearTableFilters()"
                    pTooltip="Clear Filters" tooltipPosition="bottom"></app-icon-button>
                <p-iconfield iconPosition="left">
                  <p-inputicon>
                    <fa-icon [icon]="icons.solid.faMagnifyingGlass" />
                  </p-inputicon>
                  <input 
                    pInputText 
                    type="text" 
                    placeholder="Filter results..." 
                    (input)="onFilterInput($event)"
                    (click)="$event.stopPropagation()"
                    class="p-inputtext-sm">
                </p-iconfield>
              </div>
            </div>
          </ng-template>
          
          <ng-template pTemplate="header">
            <tr (click)="$event.stopPropagation()">
              <app-table-headers [columns]="searchColumns()"></app-table-headers>
              <th class="text-center">Actions</th>
            </tr>
          </ng-template>
          
          <ng-template pTemplate="body" let-result>
            <tr class="search-result-row">
              <app-table-columns 
                [columns]="searchColumns()" 
                [data]="result"
             >
              </app-table-columns>
              
              <!-- Actions column -->
              <td>
                <div class="flex justify-center gap-1">
                  <button type="button" class="p-button p-button-outlined p-button-sm p-button-icon-only"
                  pTooltip="Log Activity" tooltipPosition="top"  (click)="openLogActivity(result)">
                  <fa-icon [icon]="icons.solid.faComment"></fa-icon>
                              </button>
                              <button type="button" class="p-button p-button-outlined p-button-sm p-button-icon-only"
                  pTooltip="Schedule Activity" tooltipPosition="top" (click)="openScheduleActivity(result)">
                  <fa-icon [icon]="icons.solid.faCalendar"></fa-icon>
                              </button>
                </div>
              </td>
            </tr>
          </ng-template>

          <!-- Virtual Scroll Loading Template -->
          <ng-template pTemplate="loadingbody" let-columns="columns">
            <tr *ngFor="let i of [1,2,3,4,5]" class="skeleton-row">
              <td *ngFor="let col of columns" class="p-3">
                <div class="skeleton-line" [style.width.%]="getSkeletonWidth(col.field)"></div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        

      </div>
      
      <!-- No Results Message -->
      <div *ngIf="searchResults().length === 0 && !isLoading() && hasPerformedSearch() && !searchError() && totalResultCount() === 0" class="no-results">
        <i class="pi pi-search"></i>
        <span class="ml-2">No results found for "{{ searchValue }}"</span>
      </div>
    </div>
  </p-popover>
</div>

<!-- Mobile Mode - Direct Display -->
<div *ngIf="isMobileMode()" class="mobile-search-content h-full flex flex-col">
  <div class="search-input-container py-4 border-b border-gray-200">
    <div class="search-input-container-mobile">
      <input 
        #searchInputMobile
        type="text"
        placeholder="Search..." 
        class="search-input-mobile"
        [(ngModel)]="searchValue"
        (input)="onInputChange($event)"
        (keyup.enter)="onEnterKeyPress()">
      <button 
        *ngIf="searchValue && searchValue.length > 0"
        type="button" 
        class="clear-button-mobile"
        (mousedown)="clearSearch(); $event.stopPropagation()"
        pTooltip="Clear search"
        tooltipPosition="bottom">
        <fa-icon [icon]="icons.solid.faXmark"></fa-icon>
      </button>
      <button 
        type="button" 
        class="search-button-mobile"
        (mousedown)="onSearchButtonClick(); $event.stopPropagation()">
        <fa-icon [icon]="icons.solid.faMagnifyingGlass"></fa-icon>
      </button>
    </div>
  </div>
  
  <!-- Loading Spinner -->
  <div *ngIf="isLoading()" class="search-loading p-4 text-center">
    <p-progressSpinner [style]="{'width': '20px', 'height': '20px'}" strokeWidth="3"></p-progressSpinner>
    <span class="ml-2">Searching...</span>
  </div>
  
  <!-- Search Error -->
  <div *ngIf="searchError()" class="search-error p-4 text-center text-red-600">
    <i class="pi pi-exclamation-triangle"></i>
    <span class="ml-2">{{ searchError() }}</span>
  </div>
  

  <!-- Search Results Table -->
  <div *ngIf="searchResults().length > 0 && !isLoading()" class="search-results flex-1 overflow-hidden" [class.few-results]="!useTableScrolling()">
    <p-table 
      #searchResultsTable
      [value]="searchResults()" 
      [scrollable]="useVirtualScrolling() || useTableScrolling()"
      [scrollHeight]="useVirtualScrolling() ? 'flex' : (useTableScrolling() ? 'flex' : undefined)"
      [stripedRows]="true"
      [sortMode]="'multiple'"
      sortField="groupId"
      [sortOrder]="1"
      [globalFilterFields]="['type', 'groupId', 'nsNum', 'name', 'company', 'phone1', 'phone2', 'email']"
      [virtualScroll]="useVirtualScrolling()"
      [virtualScrollItemSize]="46"
      [paginator]="false"
      [totalRecords]="totalResultCount()"
      styleClass="p-datatable-sm h-full">
      
      <ng-template pTemplate="caption">
        <div class="flex justify-between items-center" (click)="$event.stopPropagation()">
          <div class="flex items-center gap-3">
            <div class="flex gap-1">
              <app-icon-button [icon]="icons.ppmSolid.csv" [text]="false" (onClick)="exportCSV()"
                  pTooltip="CSV" tooltipPosition="bottom"></app-icon-button>
            </div>
            <div class="text-sm text-gray-600">
              {{ totalResultCount() }} results
            </div>
          </div>
          <div class="flex items-center gap-2">
            <app-icon-button [icon]="icons.ppmSolid.clearFilter" (onClick)="clearTableFilters()"
                pTooltip="Clear Filters" tooltipPosition="bottom"></app-icon-button>
            <p-iconfield iconPosition="left">
              <p-inputicon>
                <fa-icon [icon]="icons.solid.faMagnifyingGlass" />
              </p-inputicon>
              <input 
                pInputText 
                type="text" 
                placeholder="Filter results..." 
                (input)="onFilterInput($event)"
                (click)="$event.stopPropagation()"
                class="p-inputtext-sm">
            </p-iconfield>
          </div>
        </div>
      </ng-template>
      
      <ng-template pTemplate="header">
        <tr (click)="$event.stopPropagation()">
          <app-table-headers [columns]="searchColumns()"></app-table-headers>
        </tr>
      </ng-template>
      
      <ng-template pTemplate="body" let-result>
        <tr class="search-result-row">
          <app-table-columns [columns]="searchColumns()" [data]="result"></app-table-columns>
        </tr>
      </ng-template>

      <!-- Virtual Scroll Loading Template (Mobile) -->
      <ng-template pTemplate="loadingbody" let-columns="columns">
        <tr *ngFor="let i of [1,2,3,4,5]" class="skeleton-row">
          <td *ngFor="let col of columns" class="p-3">
            <div class="skeleton-line" [style.width.%]="getSkeletonWidth(col.field)"></div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    

  </div>
  
  <!-- No Results Message -->
  <div *ngIf="searchResults().length === 0 && !isLoading() && hasPerformedSearch() && !searchError() && totalResultCount() === 0" class="no-results p-4 text-center text-gray-500">
    <i class="pi pi-search"></i>
    <span class="ml-2">No results found for "{{ searchValue }}"</span>
  </div>
</div>